import { render } from "./FundView.vue?vue&type=template&id=4c7e5afe&ts=true"
import script from "./FundView.vue?vue&type=script&lang=ts"
export * from "./FundView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__